import { render, staticRenderFns } from "./BusinessBranchDetails.vue?vue&type=template&id=ab9a9206&"
import script from "./BusinessBranchDetails.vue?vue&type=script&lang=ts&"
export * from "./BusinessBranchDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports